import { add, isSameDay, isValid, isBefore, isAfter, startOfDay } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';

export const useAvailabilityDates = () => {
  const { booking } = useBooking();

  function getAvailabilityDates(accommodationCalendar) {
    const ranges = accommodationCalendar;
    if (!ranges?.length) return;

    try {
      let datesAreInRange = false;
      const startDate = new Date(booking.value.date_from);
      const endDate = new Date(booking.value.date_to);
      const today = startOfDay(new Date());

      if (!isValid(startDate) || !isValid(endDate)) return;

      // past dates (e.g. stale ones from sessionStorage) are never valid, fall through to first available range
      for (const interval of isBefore(startDate, today) ? [] : ranges) {
        const intervalStartDate = new Date(interval.date_from);
        const intervalEndDate = new Date(interval.date_to);

        if ((isAfter(startDate, intervalStartDate) || isSameDay(startDate, intervalStartDate)) && (isBefore(endDate, intervalEndDate) || isSameDay(endDate, intervalEndDate))) {
          datesAreInRange = true;
          return {
            from: format(toZonedTime(new Date(startDate), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' }),
            to: format(toZonedTime(new Date(endDate), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' }),
          };
        }
      }

      if (!datesAreInRange) {
        let newStartDate = null;
        let newEndDate = null;
        let validRangeFound = false;

        for (const interval of ranges) {
          const intervalEnd = new Date(interval.date_to);
          
          // Check if we can fit both the start date and next day in this interval
          const intervalStart = new Date(interval.date_from);
          const potentialStartDate = isBefore(intervalStart, today) ? today : intervalStart;
          const potentialEndDate = add(potentialStartDate, { days: 1 });
          
          if ((isBefore(potentialEndDate, intervalEnd) || isSameDay(potentialEndDate, intervalEnd))) {
            newStartDate = format(toZonedTime(new Date(potentialStartDate), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' });
            newEndDate = format(toZonedTime(new Date(potentialEndDate), 'Europe/Zagreb'), 'yyyy-MM-dd', { timeZone: 'Europe/Zagreb' });
            validRangeFound = true;
            return { from: format(newStartDate, 'yyyy-MM-dd'), to: format(newEndDate, 'yyyy-MM-dd') };
          }
        }

        if (!validRangeFound) return false;
      }
    } catch(error) {
      console.log('Error in getting availability dates', error);
    }
  }

  async function updateSearchDates(accommodationAvailabilityCalendar, datesCalculated = false) {
    // every unit inside accommodationsData has the availability calendar
    const availabilityDates = !datesCalculated ? getAvailabilityDates(accommodationAvailabilityCalendar) : accommodationAvailabilityCalendar;
    if (availabilityDates) {
      if (!(isSameDay(availabilityDates.from, booking.value.date_from && isSameDay(availabilityDates.to, booking.value.date_to)))) {
        booking.value.date_from = availabilityDates.from;
        booking.value.date_to = availabilityDates.to;
        booking.value.dates = [availabilityDates.from, availabilityDates.to];
        if (import.meta.client) sessionStorage.setItem('booking', JSON.stringify(booking.value))
      }
    }
  }

  return {
    getAvailabilityDates,
    updateSearchDates,
  }
}
